import { useWalkMeRouteSync } from '@/hooks/useWalkMeRouteSync';

const WalkMeRouteSync = (): null => {
  useWalkMeRouteSync();

  return null;
};

export default WalkMeRouteSync;
